<!--
  @修改人：黎柏祺
  @修改时间：2018-11-28
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @负责人：libaiqi
  @创建日期：2018-9-21
  @版本号：V1.0.20
  @描述： 配置托管中心
-->
<template>
  <div class="uclConfig__content">
    <div class="uclConfig__operation">
      <el-button type="primary"  size="large" @click="e_configuration">{{ $t('uclConfig.configuration') }}</el-button>
    </div>
    <div class="uclConfig__form">
       <el-form ref="form" :model="form" :inline="true">
        <el-form-item :label="$t('uclConfig.group')">
          <g-select :list="groupList" defaultAll v-model="form.groupId"></g-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.app')">
          <el-select v-model="form.appName">
            <el-option :label="item" :value="item" v-for="(item,index) in appList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.env')">
          <el-select v-model="form.envId">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in envList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.version')">
          <el-select v-model="form.version">
            <el-option :label="item" :value="item" v-for="(item,index) in versionList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="e_search" v-g-rac="gRac('uclConfig@search')">{{ $t('uclConfig.search') }}</el-button>
        </el-form-item>
      </el-form>         
    </div>
    <div class="uclConfig__table">
      <el-card class="box-card--table">
        <div slot="header" class="clearfix">
          <span>{{ $t('uclConfig.env') }}:{{envName}} </span>
          <span>{{ $t('uclConfig.app') }}:{{form.appName}}</span>
          <el-button style="float: right;" type="primary" @click="e_multiDownload" v-g-rac="gRac('uclConfig@multiDownload')">{{$t('uclConfig.multiDownload')}}</el-button>
          <el-button style="float: right;margin-right: 8px" type="primary" @click="e_multiUpload">{{$t('uclConfig.multiUpload')}}</el-button>
          <el-button style="float: right;" type="primary" @click="e_createConfig">{{$t('uclConfig.createConfig')}}</el-button>
          <el-button style="float: right;" type="primary" @click="e_clone">{{$t('uclConfig.clone')}}</el-button>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="appName"
            :label="$t('uclConfig.table.appName')">
          </el-table-column>
          <el-table-column
            prop="version"
            :label="$t('uclConfig.table.version')">
          </el-table-column>
          <el-table-column
            prop="path"
            :label="$t('uclConfig.table.path')">
          </el-table-column>
          <el-table-column
            prop="key"
            :label="$t('uclConfig.table.key')">
          </el-table-column>
          <el-table-column
            :label="$t('uclConfig.table.content')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="e_getContent(scope.row)">{{$t('uclConfig.table.getContent')}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="machineList"
            :label="$t('uclConfig.table.machineList')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="e_getMachineList(scope.row)">{{scope.row.machineList|machineCount}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="modifyTime"
            :label="$t('uclConfig.table.modifyTime')">
          </el-table-column>
          <el-table-column
            :label="$t('common.handle')"
            fix="right">
            <template slot-scope="scope">
              <el-button type="text"  @click="e_edit((scope.row))">{{$t('common.edit')}}</el-button>
              <el-dropdown  @command="handleCommand">
                <el-button type="text" >
                  {{$t('common.more')}}<i class="uk-icon-arrow-down uk-icon--right"></i>
                </el-button>
                <el-dropdown-menu  slot="dropdown">
                  <el-dropdown-item :command="{data:scope.row, fun:e_delete}" v-text="$t('common.delete')" v-g-rac="gRac('uclConfig@delete')"></el-dropdown-item>
                  <el-dropdown-item :command="{data:scope.row, fun:e_download}" v-text="$t('common.download')" v-g-rac="gRac('uclConfig@download')"></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <el-dialog :closeOnClickModal="false" :title="$t('uclConfig.createConfig')" :visible.sync="dialogFormVisible">
      <el-form :model="configForm" label-position="left" label-width="120px" ref="configForm" :rules="configFormRule">
        <el-form-item :label="$t('uclConfig.group')" prop="groupId">
          <el-select v-model="configForm.groupId">
            <el-option :label="item" :value="index" v-for="(item,index) in groupList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.app')" prop="appName">
          <el-select v-model="configForm.appName">
            <el-option :label="item" :value="index" v-for="(item,index) in e_appList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.env')" prop="envId">
            <el-select v-model="configForm.envId">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in envList" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.version')" prop="version">
            <el-select v-model="configForm.version">
              <el-option :label="item" :value="item" v-for="(item,index) in e_versionList" :key="index"></el-option>
            </el-select>
            <el-input v-show="configForm.version === $t('uclConfig.custom')" v-model="customVersion"></el-input>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.key')" prop="key">
          <el-input v-model="configForm.key" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.value')">
          <el-input v-model="configForm.value" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitForm" v-g-rac="gRac('uclConfig@Create')">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :closeOnClickModal="false" :title="contentTitle" :visible.sync="contentFormVisible" >
      <el-form :model="contentForm" ref="contentForm" >
        <div class="code-editor-wrap">
          <codemirror :value="contentForm.fileContent"
            :options="editorOptions"
            @change="codeChange"  
          ></codemirror>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAmend">{{$t('common.cancel')}}</el-button>
        <el-button v-if="isAmend" type="primary" @click="submitContent" v-g-rac="gRac('uclConfig@Update')">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :closeOnClickModal="false" :title="$t('uclConfig.machineList')" :visible.sync="machineListVisible" >
      <el-table
        :data="machineList"
        style="width: 100%">
        <el-table-column
          prop="machine"
          :label="$t('uclConfig.machine')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="value"
          :label="$t('uclConfig.value')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('uclConfig.status')">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :closeOnClickModal="false" :title="$t('uclConfig.multiUpload')" :visible.sync="uploadFormVisible" @close="resetUploadForm">
      <div class="uclConfig__uploadForm">
        <el-form :model="uploadForm" label-position="left" label-width="80px" ref="uploadForm">
          <el-form-item :label="$t('uclConfig.group')">
            <el-input disabled :value="form.groupId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uclConfig.app')" >
            <el-input disabled :value="form.appName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uclConfig.env')">
            <el-input disabled :value="envName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uclConfig.version')">
            <el-select v-model="uploadForm.version">
              <el-option :label="item" :value="item" v-for="(item,index) in v_versionList" :key="index"></el-option>
            </el-select>
            <el-input v-show="uploadForm.version === $t('uclConfig.custom')" v-model="customVersion"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uclConfig.path')" >
            <el-input v-model="uploadForm.defaultDir"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uclConfig.file')"  input-width="auto">
            <el-upload
              class="uclConfig__upload"
              ref="upload"
              :action="uploadUrl"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-success="uploadSuccess"
              :data="uploadData"
              :auto-upload="false"
              multiple
              show-file-list
              name="myfilerar"
              :file-list="fileList">
              <el-button size="small" type="primary" slot="trigger">{{$t('uclConfig.check')}}</el-button>
            </el-upload>
            <div class="uclConfig__uploadPath">
              <el-input v-model="dirList[index]" :placeholder="$t('uclConfig.inputPath')" size="small" v-for="(item,index) in fileList" :key="index"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFormVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitUploadForm" v-g-rac="gRac('uclConfig@Upload')">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :closeOnClickModal="false" :title="$t('uclConfig.clone')" :visible.sync="cloneFormVisible">
      <el-form label-position="left" label-width="120px" ref="cloneForm">
        <el-form-item :label="$t('uclConfig.app')">
          <el-input disabled :value="form.appName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.originVersion')" >
          <el-input disabled :value="form.version"></el-input>
        </el-form-item>
        <el-form-item :label="$t('uclConfig.targetVersion')">
          <el-input v-model="newVersion"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetCloneForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitCloneForm" v-g-rac="gRac('uclConfig@clone')">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import dic from '@/components/mixins/dic'
  import uclConfigBiz from '@/logic/continuousDelivery/uclConfigBiz.js'
  import validateConfig from '@/utils/validate'
  import rac from '@/plugins/rac-mixin.js'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [dic, rac],
    data () {
      return {
        form: {
          groupId: '',
          appName: '',
          version: '',
          envId: ''
        },
        configForm: {
          groupId: '',
          appName: '',
          envId: '',
          version: '',
          key: '',
          value: ''
        },
        contentForm: {
          fileContent: ''
        },
        uploadForm: {
          version: '',
          defaultDir: ''
        },
        dirList: [],
        contentTitle: '',
        configFormRule: {},
        uploadFormRule: {},
        customVersion: '',
        tableData: [],
        dialogFormVisible: false,
        contentFormVisible: false,
        machineListVisible: false,
        uploadFormVisible: false,
        cloneFormVisible: false,
        isUpload: false,
        appList: null,
        versionList: [],
        e_appList: null,
        v_versionList: [],
        e_versionList: [],
        editFlag: false,
        envList: {},
        envName: '',
        isAmend: false,
        editorOptions: {
          tabSize: 2,
          styleActiveLine: false,
          lineNumbers: true,
          line: true,
          theme: 'idea',
          foldGutter: true,
          styleSelectedText: true,
          gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
          mode: 'text/x-sh',
          // 快捷键 可提供三种模式 sublime、emacs、vim
          //                    keyMap: "sublime",
          matchBrackets: true,
          showCursorWhenSelecting: true
        },
        appId: '',
        machineList: [],
        uploadData: {},
        uploadUrl: '/api/web/config/file',
        fileList: [],
        responseList: [],
        newVersion: '',
        groupList: {}
      }
    },
    computed: {
    },
    filters: {
      machineCount (num) {
        return !num ? `0台机器` : `${num.length}台机器`
      }
    },
    methods: {
      e_init () {
        uclConfigBiz.getEnvList().then(data => {
          this.envList = data.dataList
          this.form.envId = data.dataList[0].id
        })
        this.waitAppList(this.form.groupId, 1)
        const array = ['groupId', 'envId', 'version']
        array.map((item) => {
          this.configFormRule[item] = [{ ...validateConfig.common.notEmpty }]
        })
        this.configFormRule.envId = [{ required: true, message: this.$t('uclConfig.rules.envId'), trigger: 'change' }]
      },
      async waitGroupList () {
        await this.dGetGroup()
        this.groupList = this.$store.state.dicModule.group
      },
      async waitAppList (group, val) {
        await this.dGetAppByGroup('', group)
        if (val === 1) {
          this.appList = { ...this.dDictionaryApp[group] }
          this.form.appName = Object.keys(this.appList).length !== 0 ? Object.keys(this.appList)[0] : ''
        }
        if (val === 2) {
          this.e_appList = { ...this.dDictionaryApp[group] }
          this.configForm.appName = Object.keys(this.e_appList).length !== 0 ? Object.keys(this.e_appList)[0] : ''
        }
      },
      e_configuration () {
        this.$router.push({ path: '/home/uclConfig/uclConfiguration' })
      },
      e_search () {
        let d = {
          ...this.form
        }
        if (d.version === '') {
          this.tableData = []
          this.appId = ''
          this.$message({
            message: this.$t('uclConfig.versionEmpty'),
            type: 'warning'
          })
          return
        }
        uclConfigBiz.getConfigList(d).then((data) => {
          data.dataList.forEach((item, index) => {
            item.path = item.dir === '' || item.dir === null ? item.defaultDir : item.dir
          })
          this.tableData = data.dataList
          if (this.tableData.length === 0) return
          this.appId = this.tableData[0].appId
        })
      },
      codeChange (val) {
        this.contentForm.fileContent = val
      },
      handleCommand (command) {
        command.fun && command.fun(command.data)
      },
      e_createConfig () {
        this.dialogFormVisible = true
        Object.keys(this.configForm).forEach((item) => {
          this.configForm[item] = ''
        })
      },
      e_clone () {
        this.cloneFormVisible = true
      },
      e_getContent (row) {
        this.isAmend = false
        uclConfigBiz.checkContent({ id: row.configId }).catch((e) => {
          if (e.success !== 'true') {
            this.$message({
              message: this.$t('common.fail'),
              type: 'warning'
            })
            return
          }
          this.contentTitle = e.result.key
          this.contentForm.fileContent = e.result.value
          this.contentFormVisible = true
        })
      },
      submitContent () {
        let params = new URLSearchParams()
        params.append('fileContent', this.contentForm.fileContent)
        uclConfigBiz.updateFile(params, this.contentForm.id).catch((e) => {
          if (e.success !== 'true') {
            this.$message({
              message: this.$t('common.fail'),
              type: 'warning'
            })
            return
          }
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.contentFormVisible = false
          this.e_search()
        })
      },
      cancelAmend () {
        this.contentFormVisible = false
      },
      e_getMachineList (row) {
        this.machineListVisible = true
        const arr = extend(true, [], !row.machineList ? [] : row.machineList)
        arr.forEach((item) => {
          item.errorList = item.errorList.length === 0 ? '正常' : item.errorList
        })
        this.machineList = arr
      },
      e_download (row) {
        uclConfigBiz.singleDownload(row.configId)
      },
      e_multiUpload () {
        this.isUpload = true
        this.uploadFormVisible = true
      },
      e_multiDownload (data) {
        let d = {}
        d.appId = this.appId
        d.envId = this.form.envId
        d.version = this.form.version
        uclConfigBiz.multiDownload(d)
      },
      e_edit (row) {
        this.isAmend = true
        uclConfigBiz.checkContent({ id: row.configId }).then((data) => {
          this.contentTitle = data.result.key
          this.contentForm.fileContent = data.result.value
          this.contentForm.id = row.configId
          this.contentFormVisible = true
        }).catch((e) => {
          if (e.success !== 'true') {
            this.$message({
              message: this.$t('common.fail'),
              type: 'warning'
            })
            return
          }
          this.contentTitle = e.result.key
          this.contentForm.fileContent = e.result.value
          this.contentForm.id = row.configId
          this.contentFormVisible = true
        })
      },
      e_delete (row) {
        const that = this
        that.$confirm(that.$t('common.deleteTips'), that.$t('common.delete'), {
          confirmButtonText: that.$t('common.confirm'),
          cancelButtonText: that.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          uclConfigBiz.deleteConfig(row.configId).catch((e) => {
            if (e.success !== 'true') {
              this.$message({
                message: this.$t('common.fail'),
                type: 'warning'
              })
              return
            }
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            that.getVersionByApp(1).catch((e) => {
              if (!e) return
              that.versionList = e
              that.v_versionList = extend(true, [], e)
              that.v_versionList.push(that.$t('uclConfig.custom'))
              that.uploadForm.version = that.v_versionList[0]
            })
            setTimeout(() => {
              that.e_search()
            }, 100)
          })
        }).catch(() => {})
      },
      submitForm () {
        this.$refs.configForm.validate(valid => {
          if (valid) {
            if (this.configForm.version === this.$t('uclConfig.custom')) {
              if (this.customVersion === '') {
                this.$message({
                  message: this.$t('uclConfig.rules.version'),
                  type: 'warning'
                })
                return
              }
              this.configForm.version = this.customVersion
            }
            let params = new URLSearchParams()
            params.append('groupId', this.configForm.groupId)
            params.append('appName', this.configForm.appName)
            params.append('envId', this.configForm.envId)
            params.append('version', this.configForm.version)
            params.append('key', this.configForm.key)
            params.append('value', this.configForm.value)
            uclConfigBiz.addConfig(params).catch((e) => {
              if (e.success !== 'true') {
                this.$message({
                  message: this.$t('common.fail'),
                  type: 'warning'
                })
                return
              }
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.getVersionByApp(1).catch((err) => {
                if (!err) return
                this.versionList = err
                this.v_versionList = extend(true, [], err)
                this.v_versionList.push(this.$t('uclConfig.custom'))
                this.uploadForm.version = this.v_versionList[0]
              })
              setTimeout(() => {
                this.dialogFormVisible = false
                this.e_search()
              }, 500)
            })
          }
        })
      },
      submitUploadForm () {
        if (this.uploadForm.version === '' || (this.uploadForm.version === this.$t('uclConfig.custom') && this.customVersion === '')) {
          this.$message({
            message: this.$t('uclConfig.rules.version'),
            type: 'warning'
          })
          return
        }
        if (this.fileList.length !== 0) {
          this.uploadData.version = this.uploadForm.version === this.$t('uclConfig.custom') ? this.customVersion : this.uploadForm.version
          this.uploadData.groupId = this.form.groupId
          this.uploadData.appName = this.form.appName
          this.uploadData.envId = this.form.envId
          this.uploadData.defaultDir = this.uploadForm.defaultDir
          this.isUpload = false
          this.$refs.upload.submit()
        }
      },
      submitCloneForm () {
        if (this.newVersion === '' || this.form.version === '' || this.form.appName === '') {
          this.$message({
            message: this.$t('uclConfig.rules.clone'),
            type: 'warning'
          })
          return
        }
        let params = new URLSearchParams()
        if (this.appId === '') {
          this.$message({
            message: this.$t('common.fail'),
            type: 'warning'
          })
          return
        } else {
          params.append('appId', this.appId)
        }
        params.append('version', this.form.version)
        params.append('envId', this.form.envId)
        params.append('newVersion', this.newVersion)
        uclConfigBiz.clone(params).catch((e) => {
          if (e.success !== 'true') {
            this.$message({
              message: this.$t('common.fail'),
              type: 'warning'
            })
            return
          }
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.getVersionByApp(1).catch((err) => {
            if (!err) return
            this.versionList = err
            this.form.version = this.newVersion
            this.v_versionList = extend(true, [], err)
            this.v_versionList.push(this.$t('uclConfig.custom'))
            this.uploadForm.version = this.v_versionList[0]
          })
          setTimeout(() => {
            this.cloneFormVisible = false
            this.e_search()
          }, 500)
        })
      },
      resetCloneForm () {
        this.cloneFormVisible = false
      },
      beforeUpload (file) {
        this.fileList.forEach((item, index) => {
          if (item.name === file.name) {
            this.uploadData.dir = this.dirList[index]
          }
        })
      },
      handleRemove (file, fileList) {
        this.fileList.forEach((item, index) => {
          if (item.name === file.name) {
            this.fileList.splice(index, 1)
            this.dirList.splice(index, 1)
          }
        })
      },
      handleChange (file, fileList) {
        if (!this.isUpload) return
        const reg = /^.*\.(properties|xml|)$/i
        if (!reg.test(file.name)) {
          this.$message({
            message: this.$t('uclConfig.rules.upload'),
            type: 'warning'
          })
          fileList.pop()
        }
        this.fileList.forEach((item, index) => {
          if (item.name === file.name) {
            this.$message({
              message: this.$t('uclConfig.rules.repeat'),
              type: 'warning'
            })
            fileList.splice(index, 1)
            this.dirList.splice(index, 1)
          }
        })
        this.$nextTick(() => {
          this.fileList = fileList
          this.dirList.push('')
        })
      },
      uploadSuccess (response, file, fileList) {
        this.responseList.push(response)
        if (this.responseList.length === this.fileList.length) {
          try {
            this.responseList.forEach((item, index) => {
              if (item.success === 'false') {
                throw new Error(index)
              }
            })
          } catch (e) {
            this.responseList.splice(e, 1)
            this.$message({
              message: response.message.field.file,
              type: 'warning'
            })
          }
          if (this.responseList.length === this.fileList.length) {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.getVersionByApp(1).catch((e) => {
                if (!e) return
                this.versionList = e
                this.v_versionList = extend(true, [], e)
                this.v_versionList.push(this.$t('uclConfig.custom'))
                this.uploadForm.version = this.v_versionList[0]
                this.e_search()
              })
            }, 500)
          }
        }
      },
      resetUploadForm () {
        this.customVersion = ''
        this.uploadForm.version = ''
        this.uploadForm.defaultDir = ''
        this.fileList = []
        this.dirList = []
        this.responseList = []
        this.isUpload = false
        this.uploadFormVisible = false
      },
      resetForm () {
        this.dialogFormVisible = false
      },
      getVersionByApp (num) {
        let d = {}
        switch (num) {
          case 1:
            d = { ...this.form }
            delete d.version
            break
          default:
            d = { ...this.configForm }
            delete d.version
            delete d.key
            delete d.value
        }
        return new Promise((resolve, reject) => {
          uclConfigBiz.getVersionList(d).catch((e) => {
            if (e.success !== 'true') {
              this.$message({
                message: this.$t('common.fail'),
                type: 'warning'
              })
              return
            }
            reject(e.page.result)
          })
        })
      }
    },
    mounted () {
      this.e_init()
    },
    watch: {
      envList () {
        this.waitGroupList()
      },
      'form.groupId' () {
        this.waitAppList(this.form.groupId, 1)
      },
      'form.appName' () {
        const that = this
        that.getVersionByApp(1).catch((e) => {
          if (!e) return
          that.versionList = e
          that.form.version = that.versionList.length !== 0 ? e[0] : ''
          that.v_versionList = extend(true, [], e)
          that.v_versionList.push(that.$t('uclConfig.custom'))
          that.uploadForm.version = that.v_versionList[0]
        })
      },
      'configForm.groupId' () {
        this.waitAppList(this.configForm.groupId, 2)
      },
      'configForm.appName' () {
        const that = this
        that.getVersionByApp(2).catch((e) => {
          that.e_versionList = e
          that.e_versionList.push(that.$t('uclConfig.custom'))
          that.configForm.version = that.e_versionList.length !== 0 ? e[0] : ''
        })
      },
      'configForm.envId' () {
        const that = this
        that.getVersionByApp(2).catch((e) => {
          if (!e) return
          that.e_versionList = e
          that.e_versionList.push(that.$t('uclConfig.custom'))
          that.configForm.version = that.e_versionList.length !== 0 ? e[0] : ''
        })
      },
      'form.envId' () {
        this.envName = this.envList.filter((item) => item.id === this.form.envId)[0].name
        this.getVersionByApp(1).catch((e) => {
          if (!e) return
          this.versionList = e
          this.form.version = this.versionList.length !== 0 ? e[0] : ''
          this.v_versionList = extend(true, [], e)
          this.v_versionList.push(this.$t('uclConfig.custom'))
          this.uploadForm.version = this.v_versionList[0]
        })
      }
    }
  }
</script>
<style scoped>
  .uclConfig__form {
    margin: 15px 0;
  }
  .uclConfig__content .code-editor-wrap {
    border: 1px #ddd solid;
  }
  .uclConfig__content .code-editor-wrap .CodeMirror-gutters {
    background: #e7e9db;
  }
  .uclConfig__content .code-editor-wrap .CodeMirror{
    height: 200px;
    background: #e7e9db;
  }
  .uclConfig__uploadForm .el-upload-list__item-name {
    width: 40%;
  }
  .uclConfig__uploadForm .uclConfig__upload {
    position: relative;
  }
  .uclConfig__uploadForm .uclConfig__uploadPath{
    position: absolute;
    right: 25px;
    width: 45%;
    top: 47px;
  }
  .uclConfig__uploadForm .uclConfig__uploadPath .el-input.el-input--small {
    display: block;
    height: 24px;
    line-height: 24px;
    margin-bottom: 6px;
  }
</style>
    